///////////////////////////////////////////////////

import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import { debounceTime, mergeMap, withLatestFrom } from 'rxjs/operators';
import { secondaryMarketRtQuoteTabContentPersistRequested } from 'state/secondaryMarket/realtimeQuote/realtimeQuoteForm';
import type { EpicWithThunk } from 'state/state.common';

export function triggerRtQuoteTabContentEpic(): EpicWithThunk {
  return (
    actions$,
    state$,
    {
      selectors: {
        fromSecondaryMarket: {
          realtimeQuote: {
            form: { getRtQuoteTabContentToPersist },
          },
        },
      },
      scheduler,
    },
  ) =>
    actions$.pipe(
      ofType(
        'SECONDARY_MARKET_RT_FORM_FIELD_CHANGED',
        'SECONDARY_MARKET_RT_CLIENT_SELECTED',
        'SECONDARY_MARKET_DEALSPLIT_ROW_ADDED',
        'SECONDARY_MARKET_DEALSPLIT_ROW_REMOVED',
        'SECONDARY_MARKET_DEALSPLIT_ROW_CUSTODIAN_CHANGED',
        'SECONDARY_MARKET_DEALSPLIT_ROW_NOTIONAL_CHANGED',
      ),
      debounceTime(3_000, scheduler),
      withLatestFrom(state$),
      mergeMap(([action, state]) => {
        const tabContent = getRtQuoteTabContentToPersist(state, action.tabId);
        if (tabContent === undefined) {
          return EMPTY;
        }
        return of(secondaryMarketRtQuoteTabContentPersistRequested(action.tabId, tabContent));
      }),
    );
}
